import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '@/contexts/ConfigContext';
import { useInstanceId } from '@/contexts/InstanceIdContext';

export function useClientRouteHandler() {
  const { IFRAME_URL } = useConfig();
  const navigate = useNavigate();
  const { instanceId } = useInstanceId();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== IFRAME_URL) {
        return;
      }

      if (event?.data?.source !== 'antimatter-client') {
        return;
      }

      if (event?.data?.route) {
        const childRoute =
          event.data.route === '/' ? '/home' : event.data.route;
        const targetRoute = `/${instanceId}${childRoute}`;
        const targetSearch = event.data.search;
        const currentRoute = window.location.pathname;
        const currentSearch = window.location.search;

        if (currentRoute !== targetRoute || currentSearch !== targetSearch) {
          navigate(
            { pathname: targetRoute, search: targetSearch },
            { replace: true },
          );
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [IFRAME_URL, instanceId, navigate]);
}
